import { useMemo, useRef } from 'react';
import type { StackedDialogHostApi } from './stackedDialog.types';

/**
 * Makes a dialog a host for dialogs opened over it: while one is open, Escape and outside clicks close only that one,
 * whichever element has focus. A cover is released after the event that closed it, so that Escape does not then reach
 * the host as well.
 */
export const useStackedDialogHost = (onClose: () => void): StackedDialogHostApi => {
	const covers = useRef(0);
	const host = useMemo(
		() => ({
			cover: () => {
				covers.current += 1;
				return () => {
					window.setTimeout(() => {
						covers.current -= 1;
					});
				};
			},
		}),
		[]
	);
	return {
		host,
		onClose: () => {
			if (covers.current === 0) {
				onClose();
			}
		},
	};
};
